import React, { Component } from 'react';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown
} from 'reactstrap';
import {Link} from 'react-router-dom';
import AuthService from '../../components/AuthService';

class HeaderDropdown extends Component {

  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.toggle = this.toggle.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  handleClick() {
    this.Auth.logout();
  };



  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  dropAccnt() {
    let name;
    if(this.Auth.loggedIn()){
      name = this.Auth.getProfile().sub;
    }
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav>
          {name}
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem header tag="div" className="text-center"><strong>Paramètres</strong></DropdownItem>
          <Link to='/login'><DropdownItem onClick={this.handleClick}><i className="fa fa-lock"></i> Se déconnecter</DropdownItem></Link>
        </DropdownMenu>
      </Dropdown>
    );
  }

  render() {
    const { attributes } = this.props;
    return (
      this.dropAccnt()
    );
  }
}

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js